import lity from 'lity';

import {
  AsYouType,
  isPossiblePhoneNumber,
  isValidPhoneNumber,
  parsePhoneNumber,
  validatePhoneNumberLength

} from 'libphonenumber-js';


jQuery(document).ready(function ($) {
    // Patient Assessment
    var patient_assessment = {
        'dom': $('.patient-assessment'),
        'results': {
           'PainfulDiabeticNeuropathy__c':''
          ,'PDNDiabetesType__c':''
          ,'PDNQualityOfLifeImpact__c':''
          ,'PDNLengthofPain__c':''
          ,'PDNPainLevel__c':''
          ,'PDNPainLocation__c':''
          ,'PDNTreatmentsUsed__c':''
//          ,'PDNSideEffects__c':''
//        ,'PDNLimitations__c':''
          ,'PDNCurrentSatisfaction__c':''
          ,'PDNCurrentHCP__c':''
          ,'PDNRoleinJourney__c':''
          ,'Primary_Health_Insurance__c':''
          ,'Country':''
        },
        'user': {
            'first': '',
            'last': '',
            'email': '',
            'phone': '',
            'E164Phone__c': '',
            'zipcode': '',
            'timezone': ''
        },
        'current': 1,
        'popup': '',
        'uuid': '',
        'lastStep': $('.patient-assessment').data('last-step'),
        'gaconnector': {
            'all_traffic_sources': '',
            'fc_campaign': '',
            'fc_channel': '',
            'fc_content': '',
            'fc_landing': '',
            'fc_medium': '',
            'fc_referrer': '',
            'fc_source': '',
            'fc_term': '',
            'GA_Client_ID': '',
            'lc_campaign': '',
            'lc_channel': '',
            'lc_content': '',
            'lc_landing': '',
            'lc_medium': '',
            'lc_referrer': '',
            'lc_source': '',
            'lc_term': '',
            'page_visits': '',
            'time_passed': '',
            'device': '',
            'OS': '',
            'browser': '',
            'latitude': '',
            'longitude': ''
        },
        'phonetest': false,
        open: function () {
            let patientAssessmentValidationCountryCode = this.returnCountryCode();
            //this.dom.addClass('visible');
            this.popup = lity(this.dom);
            this.resetQuiz();
            this.phonetest = true;

            if(patientAssessmentValidationCountryCode == "Australia"){
                this.phonetest = false;
            }

            if(patientAssessmentValidationCountryCode == "Germany"){
                this.phonetest = false;
            }

            // Submit GTM tag of start location for popup
            this.submitGTM('Patient Assessment Start Location', 'assessment-begin', window.location.href);
        },
        createCookie: function(name, value, days) {
            // Cookie setter function
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toGMTString();
            } else {
                expires = "";
            }
            document.cookie = name + "=" + value + expires + "; path=/";
        },
        close: function () {
            // Submit GTM tag of end of popup
            this.submitGTM('Patient Assessment Exit', 'assessment-exit', window.location.href);
            //this.dom.removeClass('visible');
            this.popup.close();
            this.resetQuiz();
        },
        nextStep: function () {
            if (this.current < patient_assessment.lastStep) {
                this.current++;
                this.updateQuiz();
            } else {
                this.current++;
                this.submitQuiz();
            }
        },
        prevStep: function () {
            if (this.current > 1) {
                this.current--;
            }
            this.updateQuiz();
        },
        updateQuiz: function () {
            // update the data attr to current step
            patient_assessment.dom.find('.patient-assessment--inner').scrollTop(0);
            if (this.dom.hasClass('patient-assessment__privacy') ) {
                this.dom.removeClass('patient-assessment__privacy');
            } else if (!(this.dom.hasClass('phonetest'))) {
                this.dom.removeClass('patient-assessment__approved patient-assessment__denied');
            }
            this.dom.attr('data-step', this.current);
        },

        resetQuiz: function () {
            // reset to first step
            this.current = 1;
            // remove status classes
            this.dom.removeClass('patient-assessment__approved patient-assessment__denied');
            this.dom.removeClass('patient-assessment__continue');
            // Clear stored results
            this.results = {
                'PainfulDiabeticNeuropathy__c':''
                ,'PDNDiabetesType__c':''
                ,'PDNLengthofPain__c':''
                ,'PDNPainLevel__c':''
                ,'PDNPainLocation__c':''
                ,'PDNTreatmentsUsed__c':''
//              ,'PDNSideEffects__c':''
//              ,'PDNLimitations__c':''
                ,'PDNCurrentSatisfaction__c':''
                ,'PDNCurrentHCP__c':''
                ,'PDNRoleinJourney__c':''
                ,'Primary_Health_Insurance__c':''
            }

            // uncheck checkboxes
            this.dom.find('input[type="checkbox"]:checked').attr('checked', false);
            // update quiz
            this.updateQuiz();
        },
        saveResult: function (question, answer) {
            this.results[question] = answer;
        },
        submitGTM: function (question, questionSlug, answer) {
            patient_assessment.uuid = window.getCookie('visitorUUID');

            if (answer === 0 && questionSlug !== "rate-your-pain-level") {
                answer = "No";
            }
            if (answer === 1 && questionSlug !== "rate-your-pain-level") {
                answer = "Yes";
            }

            let GTMres = dataLayer.push({
                'event': 'VirtualPageview',
                'virtualPageURL': '/patient-assessment/' + questionSlug,
                'virtualPageTitle': question,
                'answer': answer,
                'UUID': patient_assessment.uuid
            });
        },
        getTimezone: function (date) {
            return /\((.*)\)/.exec(date.toString())[1];
        },

        //Q: 'Yes'
        //QStep: 1
        validateQuestionPainfulDiabeticNeuropathy__c: function (){
            let status = false;
            if(this.results["PainfulDiabeticNeuropathy__c"] == "Yes"){
                status = true;
            }
            return status;
        },

        // Q: 'Type 1' || 'Type 2'
        // QStep: 3
        //not part of USA
        validateQuestionPDNDiabetesType__c: function (){
            let patientAssessmentValidationCountryCode = this.returnCountryCode();
            let status = false;
            if((patientAssessmentValidationCountryCode == "United States") || (patientAssessmentValidationCountryCode == "Germany") || (  this.results["PDNDiabetesType__c"] == "Type 1" || this.results["PDNDiabetesType__c"] == "Type 2")){
                status = true;
            }
            return Boolean(status);
        },

        validateQuestionPDNQualityOfLifeImpact__c: function (){
            let patientAssessmentValidationCountryCode = this.returnCountryCode();
            let status = false;

            if((patientAssessmentValidationCountryCode == "United States") || 
               (patientAssessmentValidationCountryCode == "Germany") ||
                (  this.results["PDNQualityOfLifeImpact__c"] == "Some days"
                || this.results["PDNQualityOfLifeImpact__c"] == "Most days"
                || this.results["PDNQualityOfLifeImpact__c"] == "Every day")){
                status = true;
            }
            return status;
        },

        validateQuestionPDNLengthofPain__c: function (){
            let patientAssessmentValidationCountryCode = this.returnCountryCode();
            let status = false;

            if((patientAssessmentValidationCountryCode == "United States") || 
                (this.results["PDNLengthofPain__c"] == "1-3 years"
                || this.results["PDNLengthofPain__c"] == "4-10 years"
                || this.results["PDNLengthofPain__c"] == "More than 10 years")){
                status = true;
            }
            return status;
        },

        // Q: 4+
        // QStep: 4
        validateQuestionPDNPainLevel__c: function (){
            let status = false;
            if(parseInt(this.results["PDNPainLevel__c"]) > 4){
                status = true;
            }
            return status;
        },

        // Q: 'Foot/feet' ,'Leg(s)' ,'Arm(s)/hand(s)',
        // QStep: 5
        validateQuestionPDNPainLocation__c: function (){
            let patientAssessmentValidationCountryCode = this.returnCountryCode();
            let status = false;
            if((patientAssessmentValidationCountryCode == "United States") 
                || (patientAssessmentValidationCountryCode == "Germany")
                || (this.results["PDNPainLocation__c"].indexOf('Foot/feet') > -1)
                || (this.results["PDNPainLocation__c"].indexOf('Leg(s)') > -1)){
                status = true;
            }
            return status;
        },


        // Q: 'Prescription Medication(s)'
        // QStep: 6
        validateQuestionPDNTreatmentsUsed__c: function (){
            let status = false;
            if((this.results["PDNTreatmentsUsed__c"].indexOf('Prescription Medication(s)') > -1) ){
                status = true;
            }
            return status;
        },


        // Q: 'No'
        // QStep: 9
        validateQuestionPDNCurrentSatisfaction__c: function (){
            let patientAssessmentValidationCountryCode = this.returnCountryCode();
            let status = false;
            if((patientAssessmentValidationCountryCode == "United States") || (patientAssessmentValidationCountryCode == "Germany") ||(this.results["PDNCurrentSatisfaction__c"] == "No")){
                status = true;
            }
            return status;
        },

        // Q: Any
        // QStep: 10
        validateQuestionPDNCurrentHCP__c: function (){
            let patientAssessmentValidationCountryCode = this.returnCountryCode();
            let status = false;
            if((patientAssessmentValidationCountryCode == "United States") || (patientAssessmentValidationCountryCode == "Germany") || (this.results["PDNCurrentHCP__c"].length > 0) ){
                status = true;
            }

            return status;
        },

        //Q: Any
        //QStep: 12
        validateQuestionPDNRoleinJourney__c: function (){
            let patientAssessmentValidationCountryCode = this.returnCountryCode();
            let status = false;
            if((patientAssessmentValidationCountryCode == "United States") || (patientAssessmentValidationCountryCode == "Germany") || (this.results["PDNRoleinJourney__c"].length > 0 )){
                status = true;
            }

            return status;
        },

        // Q: "Commercial Insurance","Medicare/Medicare Advantage","Military (TRICARE/VA/Veteran’s Choice)"
        // QStep: 11
        validateQuestionPrimary_Health_Insurance__c: function (){
            let patientAssessmentValidationCountryCode = this.returnCountryCode();
            let status = false;
            if((patientAssessmentValidationCountryCode == "Australia")  ||   (patientAssessmentValidationCountryCode == "Germany")){
                status = true;
            }else{
                if(this.results["Primary_Health_Insurance__c"].indexOf("Commercial Insurance") > -1
                    || this.results["Primary_Health_Insurance__c"].indexOf("Unknown") > -1
                    || this.results["Primary_Health_Insurance__c"].indexOf("Medicare/Medicare Advantage") > -1
                    || this.results["Primary_Health_Insurance__c"].indexOf("Military (TRICARE/VA/Veteran’s Choice)") > -1){
                    status = true;
                }
            }
            return status;
        },


        // show phone number field for specific answers to question 8
        // Display phone number if one of these for medical insurance choice
        //  "Medicare/Medicare Advantage"
        //  "Military (TRICARE/VA/Veteran’s Choice)"
        //  "Commercial Insurance"
        displayPhoneNum: function () {
            let status = false;

            let patientAssessmentValidationCountryCode = this.returnCountryCode();

            if(patientAssessmentValidationCountryCode == "Australia" || patientAssessmentValidationCountryCode == "Germany" ){
                status = true;
            }else{
                if(this.results['Primary_Health_Insurance__c'] == "Medicare/Medicare Advantage"
                   ||  this.results['Primary_Health_Insurance__c'] == "Military (TRICARE/VA/Veteran’s Choice)"
                   ||  this.results['Primary_Health_Insurance__c'] == "Commercial Insurance"){
                    status = true;
                }
            }
            return status;
        },

        //run all the tests and fire off Google analytics for which step failed
        //Patiend Qualified
        approvePatient: function () {
            let approval = true;

            if(!this.validateQuestionPainfulDiabeticNeuropathy__c()) {
                approval = false;
                this.submitGTM('Patient Assessment Unqualified -- PainfulDiabeticNeuropathy__c', 'assessment-unqualified', window.location.href);
            }
            if (!this.validateQuestionPDNDiabetesType__c()) {
                approval = false;
                this.submitGTM('Patient Assessment Unqualified -- PDNDiabetesType__c', 'assessment-unqualified', window.location.href);
            }

            if (this.validateQuestionPDNQualityOfLifeImpact__c() == false) {
                approval = false;
                this.submitGTM('Patient Assessment Unqualified -- PDNQualityOfLifeImpact__c', 'assessment-unqualified', window.location.href);
            }
            if (this.validateQuestionPDNLengthofPain__c() == false) {
                approval = false;
                this.submitGTM('Patient Assessment Unqualified -- PDNLengthofPain__c', 'assessment-unqualified', window.location.href);

            }
            if (!this.validateQuestionPDNPainLevel__c()) {
                approval = false;
                this.submitGTM('Patient Assessment Unqualified -- PDNPainLevel__c', 'assessment-unqualified', window.location.href);
            }
            if (!this.validateQuestionPDNPainLocation__c()) {
                approval = false;
                this.submitGTM('Patient Assessment Unqualified -- PDNPainLocation__c', 'assessment-unqualified', window.location.href);
            }
            if (!this.validateQuestionPDNTreatmentsUsed__c()) {
                approval = false;
                this.submitGTM('Patient Assessment Unqualified -- PDNTreatmentsUsed__c', 'assessment-unqualified', window.location.href);
            }
            if (!this.validateQuestionPDNCurrentSatisfaction__c()) {
                approval = false;
                this.submitGTM('Patient Assessment Unqualified -- PDNCurrentSatisfaction__c', 'assessment-unqualified', window.location.href);
            }
            if (!this.validateQuestionPDNCurrentHCP__c()) {
                approval = false;
                this.submitGTM('Patient Assessment Unqualified -- PDNCurrentHCP__c', 'assessment-unqualified', window.location.href);
            }
            if (!this.validateQuestionPDNRoleinJourney__c()) {
                approval = false;
                this.submitGTM('Patient Assessment Unqualified -- PDNRoleinJourney__c', 'assessment-unqualified', window.location.href);
            }
            if (!this.validateQuestionPrimary_Health_Insurance__c()) {
                approval = false;
                this.submitGTM('Patient Assessment Unqualified -- Primary_Health_Insurance__c', 'assessment-unqualified', window.location.href);
            }
            return approval;
        },
        submitQuiz: function () {
            let patientAssessmentValidationCountryCode = patient_assessment.returnCountryCode();
            if (!this.displayPhoneNum()) {
                // hide phone field
                this.dom.find('#pa-input_phone').addClass('patient-assessment--question');
                this.dom.find("label[for='pa-input_phone']").addClass('patient-assessment--question');
                patient_assessment.displayTextHighQuality(false, patientAssessmentValidationCountryCode);
            } else {
                // unhide phone field
                this.dom.find('#pa-input_phone').removeClass('patient-assessment--question');
                this.dom.find("label[for='pa-input_phone']").removeClass('patient-assessment--question');
                patient_assessment.displayTextHighQuality(true, patientAssessmentValidationCountryCode);
            }

            if (this.approvePatient()) {
                this.dom.removeClass('patient-assessment__denied').addClass('patient-assessment__approved');
                // Submit GTM tag when Quiz is approved
                this.submitGTM('Patient Assessment Qualified', 'assessment-qualified', window.location.href);
            } else {
                this.dom.removeClass('patient-assessment__approved').addClass('patient-assessment__denied');

                // Submit GTM tag when Quiz is denied
                this.submitGTM('Patient Assessment Unqualified', 'assessment-unqualified', window.location.href);
            }
        },

        submitForm: function () {
            this.gatherUserInfo();
            this.gatherGAConnector();
            this.gatherCountryCode();

            if (this.validateForm()) {
                this.dom.addClass('patient-assessment__privacy');
                // Submit GTM tag when Quiz is approved ///
                this.submitGTM('Patient Assessment Form Validated', 'form-complete', window.location.href);
            } else {
                this.submitGTM('Patient Assessment Form Not Validated', 'form-incomplete', window.location.href);
            }
        },

        checkEmailBeforeSubmittingForm: function() {
            this.gatherUserInfo();
            if (this.validateForm()) {
                // Only show if part of B testing group, otherwise just submit regularly
                //
                if ( this.displayPhoneNum() && patient_assessment.phonetest
                       && (this.dom.find('.input--phone-number').length > 0)
                       && this.user.phone === '') {
                    $('#j-email-collection__form').hide();
                    $('#j-phone-confirmation-form').show();

                    this.dom.addClass('phonetest');//There is a lot of magic here
                } else {
                    this.submitForm();
                }
            }
        },

        findGetParameter: function(parameterName) {
            var result = null,
                tmp = [];
            var items = location.search.substr(1).split("&");
            for (var index = 0; index < items.length; index++) {
                tmp = items[index].split("=");
                if (tmp[0] === parameterName) {
                    result = decodeURIComponent(tmp[1]);
                }
            }
            return result;
        },

        gatherUserInfo: function () {
            this.user.email = this.dom.find('.input--email').val().trim();
            this.user.first = this.dom.find('.input--first').val();
            this.user.last = this.dom.find('.input--last').val();
            this.user.birth = this.dom.find('.input--month').val() + '/' + this.dom.find('.input--day').val() + '/' + this.dom.find('.input--year').val();

            this.user.zipcode = this.dom.find('.input--zipcode').val().trim();
            this.user.timezone = this.getTimezone(new Date());
            if (this.dom.find('.input--phone-number').length > 0) {
                this.user.phone = this.dom.find('.input--phone-number').val();
                var path = window.location.pathname;
                if (this.user.phone !== '' && this.user.phone !== null && this.user.phone !== undefined && !path.includes('en-') && !path.includes('de')) {
                dataLayer.push({
                    'event': 'phoneNumberAdded',
                    'UUID': patient_assessment.uuid
                    });
                }
            } else {
                this.user.phone = null;
            }
        },


        gatherCountryCode: function() {
            this.saveResult('Country', this.dom.find("input[name='patient_assessment_country']").val());
        },

        returnCountryCode: function() {
            this.gatherCountryCode();
            return this.results['Country'];
        },

        gatherGAConnector: function() {
            // this.gaconnector.all_traffic_sources = document.getElementsByName("all_traffic_sources")[0].value;
            this.gaconnector.all_traffic_sources = this.dom.find("input[name='all_traffic_sources']").val();
            this.gaconnector.fc_campaign         = this.dom.find("input[name='fc_campaign']").val();
            this.gaconnector.fc_channel          = this.dom.find("input[name='fc_channel']").val();
            this.gaconnector.fc_content          = this.dom.find("input[name='fc_content']").val();
            this.gaconnector.fc_landing          = this.dom.find("input[name='fc_landing']").val();
            this.gaconnector.fc_medium           = this.dom.find("input[name='fc_medium']").val();
            this.gaconnector.fc_referrer         = this.dom.find("input[name='fc_referrer']").val();
            this.gaconnector.fc_source           = this.dom.find("input[name='fc_source']").val();
            this.gaconnector.fc_term             = this.dom.find("input[name='fc_term']").val();
            this.gaconnector.GA_Client_ID        = this.dom.find("input[name='GA_Client_ID']").val();
            this.gaconnector.lc_campaign         = this.dom.find("input[name='lc_campaign']").val();
            this.gaconnector.lc_channel          = this.dom.find("input[name='lc_channel']").val();
            this.gaconnector.lc_content          = this.dom.find("input[name='lc_content']").val();
            this.gaconnector.lc_landing          = this.dom.find("input[name='lc_landing']").val();
            this.gaconnector.lc_medium           = this.dom.find("input[name='lc_medium']").val();
            this.gaconnector.lc_referrer         = this.dom.find("input[name='lc_referrer']").val();
            this.gaconnector.lc_source           = this.dom.find("input[name='lc_source']").val();
            this.gaconnector.lc_term             = this.dom.find("input[name='lc_term']").val();
            this.gaconnector.page_visits         = this.dom.find("input[name='page_visits']").val();
            this.gaconnector.time_passed         = this.dom.find("input[name='time_passed']").val();
            this.gaconnector.OS                  = this.dom.find("input[name='OS']").val();
            this.gaconnector.browser             = this.dom.find("input[name='browser']").val();
            this.gaconnector.latitude            = this.dom.find("input[name='latitude']").val();
            this.gaconnector.longitude           = this.dom.find("input[name='longitude']").val();
            this.gaconnector.device              = this.dom.find("input[name='device']").val();
        },

        firePixelEligible: function () {
            let firePixel = false;
            if(this.results['Primary_Health_Insurance__c'] == "Medicare/Medicare Advantage"){
                firePixel = true;
            }
            // check to make sure we are only on the main US site
            if (firePixel) {
                dataLayer.push({
                    'event': 'pixelEligible',
                    'UUID': patient_assessment.uuid
                });
            }
        },

        //HighQuality
        //switch up the text based on if they are high quality or not
        displayTextHighQuality: function (highQuality, country) {
            //assume only 1 by this classname
            //flip on the green check mark for the USA
            if(highQuality && country == "United States"){
                document.getElementsByClassName('patient-assessment--question-sub-title patient-assessment--question-sub-title__alt patient-assessment--high-quality-web-lead')[0].style.visibility = "visible";
                document.getElementsByClassName('patient-assessment--question-sub-title patient-assessment--question-sub-title__alt patient-assessment--high-quality-web-lead')[0].style.display = "block";
                document.getElementsByClassName('patient-assessment--question-sub-title patient-assessment--question-sub-title__alt patient-assessment--regular-web-lead')[0].style.display = "none";
            }else if(country == "United States") {
                if(document.getElementsByClassName('patient-assessment--question-sub-title patient-assessment--question-sub-title__alt patient-assessment--high-quality-web-lead')[0]){
                    document.getElementsByClassName('patient-assessment--question-sub-title patient-assessment--question-sub-title__alt patient-assessment--high-quality-web-lead')[0].style.display = "none";
                }
                if(document.getElementsByClassName('patient-assessment--question-sub-title patient-assessment--question-sub-title__alt patient-assessment--regular-web-lead')[0]){
                    document.getElementsByClassName('patient-assessment--question-sub-title patient-assessment--question-sub-title__alt patient-assessment--regular-web-lead')[0].style.visibility = "visible";
                }
                if(document.getElementsByClassName('patient-assessment--question-sub-title patient-assessment--question-sub-title__alt patient-assessment--regular-web-lead')[0]){
                    document.getElementsByClassName('patient-assessment--question-sub-title patient-assessment--question-sub-title__alt patient-assessment--regular-web-lead')[0].style.display = "block";
                }
            }
        },



        firePixelPAQualHighQuality: function () {
            let firePixel = false;

            let patientAssessmentValidationCountryCode = patient_assessment.returnCountryCode();

            if(this.results['Primary_Health_Insurance__c'] == "Medicare/Medicare Advantage"){
                firePixel = true;
            }
            //need to add a filter when we add non assessment locations
            if (firePixel) {
                dataLayer.push({
                    'event': 'PAQualHighQuality',
                    'UUID': patient_assessment.uuid
                });
            }
//          patient_assessment.displayTextHighQuality(firePixel, patientAssessmentValidationCountryCode);
        },
        validateQuestionNextStepPainLocation: function (selections) {
            var status = true;
            if(selections.length === 0){
                status = false;
            }
            return status;
        },
        validateQuestionNextStepTreatmentsTried: function (selections) {
            var status = true;
            if(selections.length === 0){
                status = false;
            }
            return status;
        },
        validateForm: function () {
            var isValid = true;
            if (!this.validateNameFields()) {
                isValid = false;
                //this.submitGTM('Patient Assessment Form Not Validated -- Name Fields','form-incomplete', window.location.href );
            }
            if (!this.validateDateOfBirth()) {
                isValid = false;
                this.submitGTM('Patient Assessment Form Not Validated -- Date Of Birth', 'form-incomplete', window.location.href);
            }
            if (!this.validateEmail()) {
                isValid = false;
                this.submitGTM('Patient Assessment Form Not Validated -- Email', 'form-incomplete', window.location.href);
            }
            if (!this.validateZipCode()) {
                isValid = false;
                this.submitGTM('Patient Assessment Form Not Validated -- Zip Code', 'form-incomplete', window.location.href);
            }
            if (!this.validatePhone()) {
                isValid = false;
                this.submitGTM('Patient Assessment Form Not Validated -- Phone Number', 'form-incomplete', window.location.href);
            }
            return isValid;
        },
        testEmail: function (email) {
            var error_code = '';

            if (email.length === 0) {
                error_code = 0;
                return error_code;
            }

            if (email.indexOf('@') === -1) {
                error_code = email.indexOf('@');
                return error_code;
            }

            if (email.indexOf(' ') !== -1) {
                error_code = 1;
                return error_code;
            }

            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (!re.test(email)) {
                error_code = -2;
                return error_code;
            }
        },

        testZipCode: function (zipcode) {
            this.gatherCountryCode();//required to make sure this.values.Country is populated

            let patientAssessmentValidationCountryCode = this.returnCountryCode();
            let error_code = '';
            if(patientAssessmentValidationCountryCode == "Australia"){
                var re = /^(?:(?:[2-8]\d|9[0-7]|0?[28]|0?9(?=09))(?:\d{2}))$/;
                if (!re.test(zipcode)) {
                    error_code = 2;
                    return error_code;
                }
//             }else if(patientAssessmentValidationCountryCode == "Germany"){
//                 var re = /\d{5}-\d{4}$|^\d{5}$/;
//                 if (!re.test(zipcode)) {
//                     error_code = 2;
//                     return error_code;
//                 }
//             }else if(patientAssessmentValidationCountryCode == "United States"){
            } else {
                var re = /\d{5}-\d{4}$|^\d{5}$/;
                if (!re.test(zipcode)) {
                    error_code = 2;
                    return error_code;
                }
            }
            return error_code;
        },


        // validation ___________________///
        validateNameFields: function () {
            var result = true;
            if (this.user.first.trim().length < 1) {
                result = false;
                this.dom.find('.input--first').parents('.gfield').addClass('has-error');
                this.submitGTM('Patient Assessment Form Not Validated -- First Name', 'form-incomplete', window.location.href);
            } else {
                this.dom.find('.input--first').parents('.gfield').removeClass('has-error');
            }

            if (this.user.last.trim().length < 1) {
                result = false;
                this.dom.find('.input--last').parents('.gfield').addClass('has-error');
                this.submitGTM('Patient Assessment Form Not Validated -- Last Name', 'form-incomplete', window.location.href);
            } else {
                this.dom.find('.input--last').parents('.gfield').removeClass('has-error');
            }
            return result;
        },
        validateDateOfBirth: function () {
            // First check for the pattern
            if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(this.user.birth)) {
                this.dom.find('.input--year').parents('.gfield').addClass('has-error');
                this.submitGTM('Patient Assessment Form Not Validated -- Birth Year', 'form-incomplete', window.location.href);
                return false;
            }
            // Parse the date parts to integers
            var parts = this.user.birth.split("/");
            var day = parseInt(parts[1], 10);
            var month = parseInt(parts[0], 10);
            var year = parseInt(parts[2], 10);

            // Check the ranges of month and year
            if (year < 1000 || year > 3000 || month === 0 || month > 12) {
                this.dom.find('.input--year').parents('.gfield').addClass('has-error');
                this.submitGTM('Patient Assessment Form Not Validated -- Birth Year', 'form-incomplete', window.location.href);
                return false;
            }

            var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

            // Adjust for leap years
            if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
                monthLength[1] = 29;
            }

            // Check the range of the day
            if (day > 0 && day <= monthLength[month - 1]) {
                this.dom.find('.input--year').parents('.gfield').removeClass('has-error');
                return true;
            } else {
                this.dom.find('.input--year').parents('.gfield').addClass('has-error');
                return false;
            }
        },
        validateEmail: function () {
            var result = true;
            var error_code = this.testEmail(this.user.email);
            var error_message = '';

            switch (error_code) {
                case 0:
                    error_message = 'Email address required';
                    break;
                case -1:
                    error_message = 'An @ sign is required';
                    break;
                case 1:
                    error_message = 'Please remove whitespace';
                    break;
                default:
                    error_message = 'Please enter a valid email address';
            }

            if (error_code <= 1) {
                result = false;
                this.dom.find('.input--email').parents('.gfield').addClass('has-error');
                this.dom.find("label[for='input_2_3'] > span").text(error_message);
            } else {
                this.dom.find('.input--email').parents('.gfield').removeClass('has-error');
            }

            return result;
        },
        validateZipCode: function () {
            var result = true;
            var error_code = this.testZipCode(this.user.zipcode);
            var error_message = '';

            if (this.user.zipcode.length < 1) {
                result = false;
                error_message = 'Zip Code required';
                this.dom.find('.input--zipcode').parents('.gfield').addClass('has-error');
                this.submitGTM('Patient Assessment Form Not Validated -- Zip Code', 'form-incomplete', window.location.href);
            } else {
                this.dom.find('.input--zipcode').parents('.gfield').removeClass('has-error');
            }

            if (error_code === 2) {
                result = false;
                this.dom.find('.input--zipcode').parents('.gfield').addClass('has-error');
            } else {
                this.dom.find('.input--zipcode').parents('.gfield').removeClass('has-error');
            }
            return result;
        },

        validatePhone : function(){
            var result = true;
            let patientAssessmentValidationCountryCode = this.returnCountryCode();
            let validatePhoneValue = this.user.phone;
            if(validatePhoneValue.length > 0) {
                if(patientAssessmentValidationCountryCode == "United States"){
                    if( (validatePhoneValue.length > 0)  && !isValidPhoneNumber(validatePhoneValue, 'US') ){
                        result = false;
                        this.dom.find('.ginput_container_phone-number').parents('.gfield').addClass('has-error');
                    }else{
                        this.dom.find('.ginput_container_phone-number').parents('.gfield').removeClass('has-error');
                    }
                }else if(patientAssessmentValidationCountryCode == "Australia"){
                    if( (validatePhoneValue.length > 0)  && !isValidPhoneNumber(validatePhoneValue, 'AU') ){
                        result = false;
                        this.dom.find('.ginput_container_phone-number').parents('.gfield').addClass('has-error');
                    }else{
                        this.dom.find('.ginput_container_phone-number').parents('.gfield').removeClass('has-error');
                    }
                }else if(patientAssessmentValidationCountryCode == "Germany"){
                    if( (validatePhoneValue.length > 0)  && !isValidPhoneNumber(validatePhoneValue, 'DE') ){
                        result = false;
                        this.dom.find('.ginput_container_phone-number').parents('.gfield').addClass('has-error');
                    }else{
                        this.dom.find('.ginput_container_phone-number').parents('.gfield').removeClass('has-error');
                    }
                }else{
                    if(validatePhoneValue.length > 0 && validatePhoneValue.length > 20 ){
                        result = false;
                        this.dom.find('.ginput_container_phone-number').parents('.gfield').addClass('has-error');
                    }else{
                        this.dom.find('.ginput_container_phone-number').parents('.gfield').removeClass('has-error');
                    }
                }
            }
            return result;
        },

        checkExistingLead: function () {
            var values = {
                "Email": this.user.email.trim(),
                "Phone": this.user.phone,
                "E164Phone__c": patient_assessment.formatPhoneNumber( this.user.phone, "E.164")
            };
            jQuery.ajax({
                method: "POST",
                url: ajaxURL,
                data: {
                    'action': 'submit_salesforce_form',
                    'nonce': ajaxNonce,
                    'form': values,
                    'form_type': 'emailcheck'
                },
                success: function (response) {
                    if( response === 'survey exists' ){
                        patient_assessment.dom.removeClass('patient-assessment__approved patient-assessment__denied patient-assessment__privacy');
                        patient_assessment.dom.addClass('patient-assessment__survey__exists');
                        patient_assessment.submitGTM('Patient Assessment Update', 'survey-exists', window.location.href);
                    }
                    else if( response === 'no survey' ) {
//                      patient_assessment.dom.removeClass('patient-assessment__approved patient-assessment__denied patient-assessment__privacy');
//                      patient_assessment.dom.addClass('patient-assessment__survey__updated');
                        patient_assessment.finalizeSubmission('update');
                    }
                    else{
                        patient_assessment.firePixelEligible();
//                      patient_assessment.dom.removeClass('patient-assessment__approved patient-assessment__denied patient-assessment__privacy');
//                      patient_assessment.dom.addClass('patient-assessment__survey__updated');
                        patient_assessment.finalizeSubmission('new');
                    }
                }
            });
        },
        finalizeSubmission: function (task) {
            var values = {};
            // Submit GTM tag when Quiz is approved
            this.submitGTM('Patient Assessment Privacy Approved', 'submission-finalized', window.location.href);

            values = {
                "Task": task,
                "Email": this.user.email.trim(),
                "Patient_Time_zone__c": this.user.timezone,
                "All_Traffic_Sources__c": this.gaconnector.all_traffic_sources,
                "gaconnector_First_Click_Campaign__c": this.gaconnector.fc_campaign,
                "gaconnector_First_Click_Channel__c": this.gaconnector.fc_channel,
                "gaconnector_First_Click_Content__c": this.gaconnector.fc_content,
                "gaconnector_First_Click_Landing_Page__c": this.gaconnector.fc_landing,
                "gaconnector_First_Click_Medium__c": this.gaconnector.fc_medium,
                "gaconnector_First_Click_Referrer__c": this.gaconnector.fc_referrer,
                "gaconnector_First_Click_Source__c": this.gaconnector.fc_source,
                "gaconnector_First_Click_Term__c": this.gaconnector.fc_term,
                "gaconnector_Google_Analytics_Client_ID__c": this.gaconnector.GA_Client_ID,
                "gaconnector_Last_Click_Campaign__c": this.gaconnector.lc_campaign,
                "gaconnector_Last_Click_Channel__c": this.gaconnector.lc_channel,
                "gaconnector_Last_Click_Content__c": this.gaconnector.lc_content,
                "gaconnector_Last_Click_Landing_Page__c": this.gaconnector.lc_landing,
                "gaconnector_Last_Click_Medium__c": this.gaconnector.lc_medium,
                "gaconnector_Last_Click_Referrer__c": this.gaconnector.lc_referrer,
                "gaconnector_Last_Click_Source__c": this.gaconnector.lc_source,
                "gaconnector_Last_Click_Term__c": this.gaconnector.lc_term,
                "gaconnector_Number_of_Website_Visits__c": this.gaconnector.page_visits,
                "gaconnector_Time_Spent_on_Website__c": this.gaconnector.time_passed,
                "gaconnector_Operating_System__c": this.gaconnector.OS,
                "gaconnector_Browser__c": this.gaconnector.browser,
                "gaconnector_Latitude_from_IP__c": this.gaconnector.latitude,
                "gaconnector_Longitude__c": this.gaconnector.longitude,
                "Device__c": this.gaconnector.device
            };
            if (task === 'noupdate') {
                values.Request_for_patient_assessment__c = true;
            } else {
                values.Country                           = this.results['Country'];
                //values.Country                           = "United States";
                values.FirstName                         = this.user.first;
                values.LastName                          = this.user.last;
                values.PostalCode                        = this.user.zipcode;
                values.Phone                             = patient_assessment.formatPhoneNumber( this.user.phone, "NATIONAL");//TODO
//              values.Phone                             = this.user.phone;//TODO
                values.E164Phone__c                      = patient_assessment.formatPhoneNumber( this.user.phone, "E.164");
                values.Patient_DOB__c                    = this.user.birth;
                values.Request_for_patient_assessment__c = true;
                values.Primary_Health_Insurance__c       = this.results['Primary_Health_Insurance__c'];
                values.PDNCurrentHCP__c                  = this.results['PDNCurrentHCP__c'];
                values.PDNCurrentSatisfaction__c         = this.results['PDNCurrentSatisfaction__c'];
                values.PDNDiabetesType__c                = this.results['PDNDiabetesType__c'];
                values.PDNQualityOfLifeImpact__c         = this.results['PDNQualityOfLifeImpact__c'];
                values.PDNLengthofPain__c                = this.results['PDNLengthofPain__c'];
//              values.PDNLimitations__c                 = this.results['PDNLimitations__c'];
                values.PDNPainLevel__c                   = this.results['PDNPainLevel__c'];
                values.PDNPainLocation__c                = this.results['PDNPainLocation__c'];
                values.PDNRoleinJourney__c               = this.results['PDNRoleinJourney__c'];
//              values.PDNSideEffects__c                 = this.results['PDNSideEffects__c'];
                values.PDNTreatmentsUsed__c              = this.results['PDNTreatmentsUsed__c'];
                values.PainfulDiabeticNeuropathy__c      = this.results['PainfulDiabeticNeuropathy__c'];
                values.Primary_Health_Insurance__c       = this.results['Primary_Health_Insurance__c'];
            }

            let confirmationCountryCode = this.returnCountryCode();//retrieve the CountryCode so we know which pa-confirmation page we are suppose to go to.
            jQuery.ajax({
                method: "POST",
                url: ajaxURL,
                data: {
                    'action': 'submit_salesforce_form',
                    'nonce': ajaxNonce,
                    'form': values,
                    'form_type': 'pdn-pa-tool'
                },
                success: function (response) {
                    if ( task === 'new' || task =='update' || task =='noupdate') {
                        if(confirmationCountryCode == "Germany"){
                            window.location = '/de/pa-bestatigung/';
                        } else if(confirmationCountryCode == "Australia"){
                            window.location = '/en-au/pa-confirmation/';
                        }else{
                            window.location = '/pa-confirmation/';
                        }
                    }
                }
            });
        },

        formatPhoneNumber: function(inputPhoneNumber, phoneFormat){
            //this should be hard coded in the form at this point
            if(phoneFormat == "NATIONAL"){
                phoneFormat = "NATIONAL";
            }else if(phoneFormat == "E.164"){
                phoneFormat = "E.164";
            }else{
                phoneFormat = "NATIONAL";
            }

            let countryCode = this.returnCountryCode();

            if(countryCode == "United States"){
                let phoneNumber = new AsYouType('US').input(inputPhoneNumber);
                if(isValidPhoneNumber(phoneNumber, 'US') ){
                    const phoneNumberParser = parsePhoneNumber(phoneNumber, 'US');
                    phoneNumber = phoneNumberParser.format(phoneFormat);
                    return phoneNumber;
                }else{
                    return phoneNumber;
                }
            }else if(countryCode == "Germany"){
                let phoneNumber = new AsYouType('DE').input(inputPhoneNumber);
                if(isValidPhoneNumber(phoneNumber, 'DE') ){
                    const phoneNumberParser = parsePhoneNumber(phoneNumber, 'DE');
                    phoneNumber = phoneNumberParser.format(phoneFormat);
                    return phoneNumber;
                }else{
                    return phoneNumber;
                }
            }else if(countryCode == "Australia"){
                let phoneNumber = new AsYouType('AU').input(inputPhoneNumber);
                if(isValidPhoneNumber(phoneNumber, 'AU') ){
                    const phoneNumberParser = parsePhoneNumber(phoneNumber, 'AU');
                    phoneNumber = phoneNumberParser.format(phoneFormat);
                    return phoneNumber;
                }else{
                    return phoneNumber;
                }
            }else {
                return false;
            }
        },

        downloadPDF: function () {
            var results = {
                'pain_score_results': patient_assessment.filterResultForDisplay(patient_assessment.results['PDNPainLevel__c']),
                'duration_results': patient_assessment.filterResultForDisplay(patient_assessment.results['PDNLengthofPain__c']),
                'pain_location_results': patient_assessment.filterResultForDisplay(patient_assessment.results['PDNPainLocation__c']),
                'other_remedies_results': patient_assessment.filterResultForDisplay(patient_assessment.results['PDNTreatmentsUsed__c'])
            };

            var address = pdfGenerationURL + '?ps=' + results.pain_score_results + '&dur=' + results.duration_results + '&pl=' + results.pain_location_results + '&oth=' + results.other_remedies_results;
            window.open(encodeURI(address));
        },
        filterResultForDisplay: function (result) {
            return String(result).replace('Arms', 'Arm(s)')
                .replace('Legs', 'Leg(s)')
                .replace('Foot-Feet', 'Foot/Feet')
                .replace('Physical therapy', 'Physical Therapy')
                .replace('Implantable pain pump', 'Implantable Pain Pump');
        },
    };

    //////// ACTIONS /////////
    if (window.location.hash && window.location.hash === "#patient-assessment") {
        if (patient_assessment.dom.length > 0) {
            patient_assessment.open();
        }
    }
    // launch patient assessment test
    $(document).on('click', '.j-patient-assessment--open', function (e) {
        e.preventDefault();
        patient_assessment.open();
    });
    // Support for launching patient assessment from A/B test
    $(document).on('click', '.j-jump', function(e) {
        e.preventDefault();
        patient_assessment.open();
        const value = $(this).data('value');
        $('.patient-assessment--question__1 .j-patient-assessment--input[data-value="' + value + '"]').click();
    });
    // check whether email already in SFDC as lead
    patient_assessment.dom.on('click', '.patient-assessment--privacy-submit', function () {
        $(this).prop('disabled', true).addClass('o-ajax-progress');
        if (patient_assessment.validatePhone() && (patient_assessment.user.phone.length > 0)) {
            dataLayer.push({
              'event': 'phoneNumberSubmitted',
              'UUID': patient_assessment.uuid
            });
        }

        patient_assessment.checkExistingLead();
    });
    // email detected, update SFDC lead
    patient_assessment.dom.on('click', '.patient-assessment--update--submit', function () {
        patient_assessment.firePixelEligible();
        $(this).prop('disabled', true).addClass('o-ajax-progress');
        $(".patient-assessment--noupdate--submit").prop('disabled', true).addClass('o-ajax-progress');
        patient_assessment.finalizeSubmission('update');
    });
    // email detected, do NOT update SFDC lead
    patient_assessment.dom.on('click', '.patient-assessment--noupdate--submit', function () {
        $(this).prop('disabled', true).addClass('o-ajax-progress');
        $(".patient-assessment--update--submit").prop('disabled', true).addClass('o-ajax-progress');
        patient_assessment.finalizeSubmission('noupdate');
    });
    patient_assessment.dom.on('click', '.patient-assessment--close', function () {
        patient_assessment.close();
    });
    patient_assessment.dom.on('click', '.patient-assessment--back', function () {
        patient_assessment.prevStep();
        patient_assessment.dom.removeClass('patient-assessment__continue');
    });
    patient_assessment.dom.on('click', '.j-patient-assessment--input', function () {
        var _this = $(this);

        let patientAssessmentValidationCountryCode = patient_assessment.returnCountryCode();
        //patient_assessment.saveResult(_this.parents('.patient-assessment--question').data('question'), _this.data('value'), _this.data('key'));
        patient_assessment.saveResult(_this.parents('.patient-assessment--question').data('key'), _this.data('value'));
        var results_container = '.patient-assessment--results-display-answer__' + _this.parents('.patient-assessment--question').data('question');

        // Exception for first question "do you have diabetes", if no - exit PA
        if(_this.parents('.patient-assessment--question').data('key') == 'PainfulDiabeticNeuropathy__c' && _this.data('value') == 'No') {
            patient_assessment.dom.removeClass('patient-assessment__approved').addClass('patient-assessment__denied');

            // Submit GTM tag when Quiz is denied
            patient_assessment.submitGTM('Patient Assessment Unqualified', 'assessment-unqualified', window.location.href);
            patient_assessment.submitGTM(
                _this.parents('.patient-assessment--question').find('.patient-assessment--question-title').text(),
                _this.parents('.patient-assessment--question').data('question-slug'),
                _this.data('value')
            );
            return false;
        }


        //for the USA short circuit the approval process
        if(patientAssessmentValidationCountryCode == "United States"){
            
            // Exception for first question "Have you been diagnosed...", if yes - show popup
            if(_this.parents('.patient-assessment--question').data('key') == 'PainfulDiabeticNeuropathy__c' && _this.data('value') == 'Yes') {
                // patient_assessment.dom.removeClass('patient-assessment__approved').addClass('patient-assessment__continue');
                patient_assessment.dom.addClass('patient-assessment__continue');
                // patient_assessment.dom.removeClass('patient-assessment__approved').addClass('patient-assessment__denied');
    
                // Submit GTM tag when Quiz is denied
                // patient_assessment.submitGTM('Patient Assessment Unqualified', 'assessment-unqualified', window.location.href);
                // patient_assessment.submitGTM(
                //     _this.parents('.patient-assessment--question').find('.patient-assessment--question-title').text(),
                //     _this.parents('.patient-assessment--question').data('question-slug'),
                //     _this.data('value')
                // );
                // return false;
              //console.log('open continue modal');
            }

            // Exception for first question "do you have diabetes", if no - exit PA
            if(_this.parents('.patient-assessment--question').data('key') == 'PDNTreatmentsUsed__c' && _this.data('value') == 'None of the above') {
                patient_assessment.dom.removeClass('patient-assessment__approved').addClass('patient-assessment__denied');
            
                // Submit GTM tag when Quiz is denied
                patient_assessment.submitGTM('Patient Assessment Unqualified', 'assessment-unqualified', window.location.href);
                patient_assessment.submitGTM(
                    _this.parents('.patient-assessment--question').find('.patient-assessment--question-title').text(),
                    _this.parents('.patient-assessment--question').data('question-slug'),
                    _this.data('value')
                );
                return false;
            }
            
            
            // Exception for first question "do you have diabetes", if no - exit PA
            if(_this.parents('.patient-assessment--question').data('key') == 'PDNPainLevel__c' && parseInt(_this.data('value')) < 5) {
                patient_assessment.dom.removeClass('patient-assessment__approved').addClass('patient-assessment__denied');
            
                // Submit GTM tag when Quiz is denied
                patient_assessment.submitGTM('Patient Assessment Unqualified', 'assessment-unqualified', window.location.href);
                patient_assessment.submitGTM(
                    _this.parents('.patient-assessment--question').find('.patient-assessment--question-title').text(),
                    _this.parents('.patient-assessment--question').data('question-slug'),
                    _this.data('value')
                );
 
                return false;
            }
         }
 

         $(results_container).html(patient_assessment.filterResultForDisplay(_this.data('value')));
         patient_assessment.submitGTM(
             _this.parents('.patient-assessment--question').find('.patient-assessment--question-title').text(),
             _this.parents('.patient-assessment--question').data('question-slug'),
             _this.data('value')
         );

        if((patientAssessmentValidationCountryCode == "United States") &&  _this.parents('.patient-assessment--question').data('question') === 4){
            patient_assessment.firePixelPAQualHighQuality();
        }else if((patientAssessmentValidationCountryCode == "Germany") &&  _this.parents('.patient-assessment--question').data('question') === 11){
            patient_assessment.firePixelPAQualHighQuality();
        }else if((patientAssessmentValidationCountryCode == "Australia") &&  _this.parents('.patient-assessment--question').data('question') === 11){
            patient_assessment.firePixelPAQualHighQuality();
        }
        patient_assessment.nextStep();
    });
    patient_assessment.dom.on('keypress', '.j-patient-assessment--input', function (e) {
        if((e.keyCode ? e.keyCode : e.which) === 13){
            $(this).trigger('click');
        }
    });
    patient_assessment.dom.on('click', '.j-patient-assessment--next-step', function (e) {
        e.preventDefault();
        var _this = $(this);
        var container = _this.parents('.patient-assessment--question');

        var selections = container.find('input[type="checkbox"]:checked').map(function () {
            return $(this).val();
        }).get().join("; ");

        let moveOnToNext = true;
        let currentQuestionKey = _this.parents('.patient-assessment--question').data('key');

        if( (currentQuestionKey === 'PDNPainLocation__c') && !patient_assessment.validateQuestionNextStepPainLocation(selections)){
            document.getElementById('validateQuestionNextStepPainLocation').style.visibility = "visible";
            //error messages to client
            moveOnToNext = false;
        }

        if((currentQuestionKey === 'PDNTreatmentsUsed__c') && !patient_assessment.validateQuestionNextStepTreatmentsTried(selections)){
            //error messages to client
            document.getElementById('validateQuestionNextStepTreatmentsTried').style.visibility = "visible";
            moveOnToNext = false;
        }
        if(moveOnToNext){
            if(document.getElementById('validateQuestionNextStepPainLocation')){
                document.getElementById('validateQuestionNextStepPainLocation').style.visibility = "hidden";
            }
            if(document.getElementById('validateQuestionNextStepTreatmentsTried')){
                document.getElementById('validateQuestionNextStepTreatmentsTried').style.visibility = "hidden";
            }
            patient_assessment.saveResult(_this.parents('.patient-assessment--question').data('key'), selections);
            var results_container = '.patient-assessment--results-display-answer__' + _this.parents('.patient-assessment--question').data('question');
            $(results_container).html(patient_assessment.filterResultForDisplay(selections));
            patient_assessment.submitGTM(
                _this.parents('.patient-assessment--question').find('.patient-assessment--question-title').text(),
                _this.parents('.patient-assessment--question').data('question-slug'),
                selections
            );
            patient_assessment.nextStep();
        }

    });
    patient_assessment.dom.on('keypress', '.j-patient-assessment--next-step', function (e) {
        if((e.keyCode ? e.keyCode : e.which) === 13){
            $(this).trigger('click');
        }
    });

    patient_assessment.dom.on('click', '.patient-assessment--checkbox', function () {
        var _this = $(this);
        var parent = _this.parents('.patient-assessment--question-content');
        if (_this.hasClass('patient-assessment--checkbox__none')) {
            if (_this.prop('checked') !== false) {
                parent.find('.patient-assessment--checkbox:not(.patient-assessment--checkbox__none)').find('input').prop('checked', false);
            }
        } else {
            parent.find('.patient-assessment--checkbox__none').find('input').prop('checked', false);
        }
    });
    patient_assessment.dom.on('keypress', '.patient-assessment--checkbox', function (e) {
        if((e.keyCode ? e.keyCode : e.which) === 13){
            $(this).find('label').trigger('click');
        }
    });

    patient_assessment.dom.on('click', '.j-patient-assessment--start-over', function () {
        patient_assessment.resetQuiz();
    });
    patient_assessment.dom.on('keypress', '.j-patient-assessment--start-over', function (e) {
        if((e.keyCode ? e.keyCode : e.which) === 13){
            $(this).trigger('click');
        }
    });

    patient_assessment.dom.on('click', '.j-patient-assessment--continue', function () {
        patient_assessment.dom.removeClass('patient-assessment__continue');
    });

    patient_assessment.dom.on('click', '.patient-assessment--submit-force', function (e) {
        e.preventDefault();
        patient_assessment.submitForm();
    });

    patient_assessment.dom.on('click', '#patient-assessment--submit', function (e) {
        e.preventDefault();
        patient_assessment.checkEmailBeforeSubmittingForm();
    });
    // DOWNLOAD PDF
    patient_assessment.dom.on('click', '.j-patient-assessment--download-pdf', function (e) {
        e.preventDefault();
        patient_assessment.downloadPDF();
    });

    patient_assessment.dom.on('paste', '#pa-input_phone', function () {
        setTimeout(function (){
            let delayFormat  = patient_assessment.formatPhoneNumber( $("#pa-input_phone").val(), "NATIONAL");
            $("#pa-input_phone").val(delayFormat);
        },  1000);
    });

    patient_assessment.dom.on('paste', '#pa-input_phone2', function (e) {
        let inputKeyCode = e.keyCode || e.which;
        setTimeout(function (){
            let delayFormat  = patient_assessment.formatPhoneNumber( $("#pa-input_phone2").val(), "NATIONAL");
            $("#pa-input_phone").val(delayFormat);
            $("#pa-input_phone2").val(delayFormat);
        }, 1000);
    });

    patient_assessment.dom.on('keyup', '#pa-input_phone', function () {
        setTimeout(function (){
            let delayFormat  = patient_assessment.formatPhoneNumber( $("#pa-input_phone").val(), "NATIONAL");
            $("#pa-input_phone").val(delayFormat);
        },  1000);
    });

    patient_assessment.dom.on('keyup', '#pa-input_phone2', function (e) {
        let inputKeyCode = e.keyCode || e.which;
        setTimeout(function (){
            let delayFormat  = patient_assessment.formatPhoneNumber( $("#pa-input_phone2").val(), "NATIONAL");
            $("#pa-input_phone").val(delayFormat);
            $("#pa-input_phone2").val(delayFormat);
        }, 1000);
    });

    patient_assessment.dom.on('click', '.j-pa-why', function (e) {
        e.preventDefault();
        $(this).next().addClass('pa-answer--open');
        $(this).addClass('pa-why--closed');
    })

    patient_assessment.dom.on('click', '.j-pa-close', function (e) {
        e.preventDefault();
        $(this).parent('.pa-answer').removeClass('pa-answer--open');
        $(this).parent('.pa-answer').prev().removeClass('pa-why--closed');
    })
});
